import PropTypes from "prop-types";
import ReducedPrice from "./ReducedPrice";
import OriginalPrice from "./OriginalPrice";
import styles from "./index.css";

const ProductPrice = ({
  price,
  isSale,
  isOutlet,
  reducedPrice,
  hasMultiplePrices
}) => {
  const isMarkedDown = isSale || isOutlet;

  return (
    <p aria-hidden={true} className={styles.container}>
      <OriginalPrice
        price={price}
        isMarkedDown={isMarkedDown}
        isOutlet={isOutlet}
        shouldDisplayFrom={hasMultiplePrices && reducedPrice === null}
      />
      {reducedPrice && (
        <ReducedPrice
          isMarkedDown={isMarkedDown}
          reducedPrice={reducedPrice}
          hasMultiplePrices={hasMultiplePrices}
        />
      )}
    </p>
  );
};

ProductPrice.propTypes = {
  price: PropTypes.string.isRequired,
  isSale: PropTypes.bool,
  isOutlet: PropTypes.bool,
  reducedPrice: PropTypes.string,
  hasMultiplePrices: PropTypes.bool
};

ProductPrice.defaultProps = {
  hasMultiplePrices: false,
  isOutlet: false,
  reducedPrice: null,
  isSale: false
};

export default ProductPrice;
